import Select from "react-select";
import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import ItemInfo from "../../../utils/ItemInfo/ItemInfo";
import CustomDateTimePicker from "../../../utils/CustomDateTimePicker/CustomDateTimePicker";
import PaginationList from "./../../../utils/PaginationList/PaginationList";
import { ConvertCurrency } from "./../../../utils/Currency/Currency";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { discountCouponAdminContext } from "../../../context/Admin/DiscountCouponAdminContext/DiscountCouponAdminContext";
import { numberSeparate } from "../../../utils";

const DiscountCouponAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const {
    discountCouponItems,
    totalCount,
    pageNumber,
    setPageNumber,
    discountCoupon,
    services,
    search,
    setSearch,
    id,
    title_output,
    setTitle_output,
    ref_num,
    setRef_num,
    single_user,
    setSingle_user,
    amount,
    setAmount,
    percent,
    setPercent,
    max_discount_amount,
    setMax_discount_amount,
    min_invoice_amount,
    setMin_invoice_amount,
    expiration_date,
    setExpiration_date,
    is_active,
    setIs_active,
    description,
    setDescription,
    service,
    setService,
    usage_total,
    setUsage_total,
    usage_per_client,
    setUsage_per_client,
    isShowModal,
    isShowDetailsModal,
    handleCloseDetailsModal,
    handleShowModal,
    handleCloseModal,
    handleGetServices,
    handleGetDiscountCouponItemList,
    handleGetDiscountCouponItem,
    handleCreateDiscountCouponItem,
    handleEditDiscountCouponItem,
    handleDeleteDiscountCouponItem,
    managedCities,
    selectedCities,
    setSelectedCities,
  } = useContext(discountCouponAdminContext);

  useEffect(() => {
    handleGetServices();
  }, []);

  useEffect(() => {
    handleGetDiscountCouponItemList();
  }, [pageNumber]);

  return (
    <>
      <SiteTitle title="کد تخفیف" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "کد تخفیف", type: "a" },
        ]}
        title="آیتم های کد تخفیف"
      />

      <CardLayout>
        {permission.discountcoupon_create_update && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}

        <form
          className="input-group mb-3"
          onSubmit={handleGetDiscountCouponItemList}
        >
          <input
            type="text"
            name="search"
            autoComplete="off"
            placeholder="جستجو ..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>

        {isEmpty(discountCouponItems) ? (
          <EmptyData />
        ) : (
          <>
            <PaginationList
              setPageNumber={setPageNumber}
              pageCount={totalCount / 10}
            />
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>شناسه</th>
                  {/* <th>عنوان</th> */}
                  <th>دسته بندی</th>
                  <th>کد تخفیف</th>
                  <th>مقدار</th>
                  <th>حداقل مبلغ فاکتور</th>
                  <th>حداکثر مبلغ تخفیف</th>
                  <th>درصد</th>
                  <th>تک کاربره</th>
                  <th>تعداد استفاده</th>
                  <th>وضعیت</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {discountCouponItems.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.id}</td>
                    {/* <td>{_item.title_output}</td> */}
                    <td>{_item.title}</td>
                    <td>{_item.ref_num}</td>
                    <td>
                      <ConvertCurrency price={_item.amount} />
                    </td>
                    <td>
                      <ConvertCurrency price={_item.min_invoice_amount} />
                    </td>
                    <td>
                      <ConvertCurrency price={_item.max_discount_amount} />
                    </td>
                    <td>{_item.percent ?? "-"}</td>
                    <td>
                      {_item.single_user ? (
                        <i className="fa fa-check text-success" />
                      ) : (
                        <i className="fa fa-times text-danger" />
                      )}
                    </td>
                    <td>{numberSeparate(_item.total_usage)}</td>
                    <td>
                      <span
                        className={`badge badge-${_item.is_active ? "success" : "danger"
                          }`}
                      >
                        {_item.is_active ? "فعال" : "غیرفعال"}
                      </span>
                    </td>
                    <td className="mw-25">
                      {/* <button
                        onClick={() => handleGetDiscountCouponItem(_item.id)}
                        className="btn btn-info mr-2"
                      >
                        جزئیات
                      </button> */}
                      {permission.discountcoupon_create_update && (
                        <button
                          onClick={() =>
                            handleGetDiscountCouponItem(_item.id, true)
                          }
                          className="btn btn-primary mr-2"
                        >
                          جزئیات و ویرایش
                        </button>
                      )}
                      {permission.discountcoupon_delete && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteDiscountCouponItem(_item.id),
                              `آیا از حذف ${_item.title} اطمینان دارید؟`
                            )
                          }
                          type="button"
                          className="fa fa-trash-alt text-danger fa-2x"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} کد تخفیف`}
        size="lg"
        show={isShowModal}
        onHide={handleCloseModal}
      >
        <form
          onSubmit={
            id ? handleEditDiscountCouponItem : handleCreateDiscountCouponItem
          }
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="title_output">عنوان</label>
              <input
                type="text"
                id="title_output"
                name="title_output"
                className="form-control"
                value={title_output}
                onChange={(e) => setTitle_output(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="ref_num">کد تخفیف</label>
              <input
                type="text"
                id="ref_num"
                name="ref_num"
                className="form-control"
                value={ref_num}
                onChange={(e) => setRef_num(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="amount">مقدار</label>
              <input
                type="number"
                id="amount"
                name="amount"
                className="form-control"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="percent">درصد</label>
              <input
                type="number"
                id="percent"
                name="percent"
                className="form-control"
                min="0"
                max="100"
                value={percent}
                onChange={(e) => setPercent(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="max_discount_amount">حداکثر مبلغ تخفیف</label>
              <input
                type="number"
                id="max_discount_amount"
                name="max_discount_amount"
                className="form-control"
                value={max_discount_amount}
                onChange={(e) => setMax_discount_amount(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="min_invoice_amount">حداقل مبلغ فاکتور</label>
              <input
                type="number"
                id="min_invoice_amount"
                name="min_invoice_amount"
                className="form-control"
                value={min_invoice_amount}
                onChange={(e) => setMin_invoice_amount(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="usage_total">تعداد کل دفعات مجاز</label>
              <input
                type="number"
                id="usage_total"
                name="usage_total"
                className="form-control"
                value={usage_total}
                onChange={(e) => setUsage_total(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="usage_per_client">تعداد استفاده هر کاربر</label>
              <input
                type="number"
                id="usage_per_client"
                name="usage_per_client"
                className="form-control"
                value={usage_per_client}
                onChange={(e) => setUsage_per_client(e.target.value)}
              />
            </div>
            {/* در داخل فرم مودال Create/Edit */}
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="cities">شهرها (محدودسازی)</label>
              <Select
                id="cities"
                name="cities"
                options={managedCities}
                value={selectedCities}
                onChange={setSelectedCities}
                isMulti
                isRtl={true}
                placeholder="انتخاب شهرها (خالی = همه شهرها)"
                noOptionsMessage={() => "شهری یافت نشد"}
                className="basic-multi-select font-sans text-sm p-0"
                classNamePrefix="select"
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="service">دسته بندی</label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <button
                    type="button"
                    className={`btn btn-${service === "all" ? "primary" : "secondary"
                      }`}
                    onClick={() => setService(service === "all" ? [] : "all")}
                  >
                    همه
                  </button>
                </div>
                <Select
                  options={services}
                  value={service}
                  isDisabled={service === "all"}
                  className={`col p-0 ${service === "all" ? "bg-light" : ""}`}
                  isMulti
                  id="service"
                  name="service"
                  onChange={setService}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="expiration_date">تاریخ انقضا</label>
              <CustomDateTimePicker
                initValue={expiration_date}
                type="single"
                onChange={(e) => setExpiration_date(e)}
                todayBtn
                withTime
                autoClose={false}
                showTimeInput
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="description">توضیحات</label>
              <textarea
                id="description"
                name="description"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="single_user">کاربر</label>
              <div className="d-flex align-items-center">
                <label htmlFor="single_user" className="mr-2">
                  تک کاربر
                </label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={single_user}
                    id="single_user"
                    onClick={(e) => setSingle_user(e.target.checked)}
                  />
                  <span className="slider round"></span>
                </label>
                <label htmlFor="single_user" className="ml-2">
                  همه
                </label>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="is_active">وضعیت</label>
              <div className="d-flex align-items-center">
                <label htmlFor="is_active" className="mr-2">
                  فعال
                </label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={is_active}
                    id="is_active"
                    onClick={(e) => setIs_active(e.target.checked)}
                  />
                  <span className="slider round"></span>
                </label>
                <label htmlFor="is_active" className="ml-2">
                  غیرفعال
                </label>
              </div>
            </div>
          </div>
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات کد تخفیف"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="شناسه">
              <p>{discountCoupon.id}</p>
            </ItemInfo>
            {/* <ItemInfo label="عنوان">
              <p>{discountCoupon.title_output}</p>
            </ItemInfo> */}
            <ItemInfo label="دسته بندی">
              <p>{discountCoupon.title}</p>
            </ItemInfo>
            <ItemInfo label="کد تخفیف">
              <p>{discountCoupon.ref_num}</p>
            </ItemInfo>
            <ItemInfo label="مقدار">
              <ConvertCurrency price={discountCoupon.amount} />
            </ItemInfo>
            <ItemInfo label="حداقل مبلغ فاکتور">
              <ConvertCurrency
                price={discountCoupon.min_invoice_amount ?? "-"}
              />
            </ItemInfo>
            <ItemInfo label="حداکثر مبلغ تخفیف">
              <ConvertCurrency
                price={discountCoupon.max_discount_amount ?? "-"}
              />
            </ItemInfo>
            <ItemInfo label="درصد">
              <p>{discountCoupon.percent ?? "-"}%</p>
            </ItemInfo>
            <ItemInfo label="وضعیت">
              <p>
                <span
                  className={`badge badge-${discountCoupon.is_active ? "success" : "danger"
                    }`}
                >
                  {discountCoupon.is_active ? "فعال" : "غیرفعال"}
                </span>
              </p>
            </ItemInfo>
            <ItemInfo label="تک کاربره">
              <p>
                {discountCoupon.single_user ? (
                  <i className="fa fa-check text-success" />
                ) : (
                  <i className="fa fa-times text-danger" />
                )}
              </p>
            </ItemInfo>
            <ItemInfo label="تعداد استفاده">
              <p>{numberSeparate(discountCoupon.total_usage)}</p>
            </ItemInfo>
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default DiscountCouponAdmin;
